import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import { MAX_PAGE_SIZE } from '@/lib/api/max-page-size';

import {
  BUSINESS_PARTNER_DETAIL_QUERY_KEY,
  BUSINESS_PARTNER_LIST_QUERY_KEY,
} from './key';
import type { BusinessPartnerDetail, BusinessPartnerItem } from './type';

export const fetchBusinessPartners = async (
  freeText: string,
): Promise<BusinessPartnerItem[]> => {
  const res = await apiClient.GET(BUSINESS_PARTNER_LIST_QUERY_KEY, {
    params: {
      query: {
        freeText: freeText.length > 0 ? freeText : null,
        businessPartnerStatusIn: ['ACTIVE'],
        businessPartnerTypeIn: null,
        pageSize: MAX_PAGE_SIZE,
      },
    },
  });
  const data = getDataOrThrowApiError(res);
  return data.items;
};

export const fetchBusinessPartnerDetail = async (
  businessPartnerId: string,
): Promise<BusinessPartnerDetail> => {
  const res = await apiClient.GET(BUSINESS_PARTNER_DETAIL_QUERY_KEY, {
    params: { path: { businessPartnerId } },
  });
  const data = getDataOrThrowApiError(res);
  return data.businessPartner;
};
